// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * WelcomeDialog Styles
 * Designed for older users: large text, clear buttons, friendly design
 */

.welcome-dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.75);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2500; /* Above modals but below tutorial overlay */
  padding: 20px;
}

.welcome-dialog {
  /* Glassmorphism effect */
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 20px;
  padding: 40px;
  max-width: 420px;
  width: 100%;
  text-align: center;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
  animation: welcome-appear 0.4s ease-out;
}

@keyframes welcome-appear {
  from {
    opacity: 0;
    transform: scale(0.9);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

.welcome-dialog-logo {
  margin-bottom: 24px;
}

.welcome-logo {
  width: 120px;
  height: auto;
}

.welcome-title {
  font-size: 1.75rem;
  font-weight: 700;
  color: var(--color-text, #1f2937);
  margin: 0 0 20px 0;
  line-height: 1.3;
}

.welcome-message {
  font-size: 1.15rem;
  color: var(--color-text-secondary, #6b7280);
  line-height: 1.6;
  margin: 0 0 16px 0;
}

.welcome-tutorial-offer {
  font-size: 1.1rem;
  color: var(--color-text, #1f2937);
  line-height: 1.5;
  margin: 0 0 28px 0;
  font-weight: 500;
}

.welcome-actions {
  display: flex;
  gap: 16px;
  justify-content: center;
}

.welcome-btn {
  padding: 16px 32px;
  border-radius: 12px;
  font-size: 1.1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  border: none;
  min-height: 52px;
  min-width: 140px;
}

.welcome-btn-skip {
  background: var(--color-background, #f3f4f6);
  color: var(--color-text, #1f2937);
}

.welcome-btn-skip:hover {
  background: var(--color-border, #d1d5db);
}

.welcome-btn-tutorial {
  background: var(--color-primary, #3b82f6);
  color: white;
}

.welcome-btn-tutorial:hover {
  background: var(--color-primary-hover, #2563eb);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);
}

/* Mobile responsiveness */
@media (max-width: 480px) {
  .welcome-dialog {
    padding: 32px 24px;
  }

  .welcome-logo {
    width: 100px;
  }

  .welcome-title {
    font-size: 1.5rem;
  }

  .welcome-message,
  .welcome-tutorial-offer {
    font-size: 1rem;
  }

  .welcome-actions {
    flex-direction: column;
  }

  .welcome-btn {
    width: 100%;
    min-width: unset;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/WelcomeDialog.css"],"names":[],"mappings":"AAAA;;;EAGE;;AAEF;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa,EAAE,4CAA4C;EAC3D,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,oCAAoC;EACpC,2BAA2B;EAC3B,mCAAmC;EACnC,0CAA0C;EAC1C,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,yCAAyC;EACzC,uCAAuC;AACzC;;AAEA;EACE;IACE,UAAU;IACV,qBAAqB;EACvB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,2CAA2C;EAC3C,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,iCAAiC;EACjC,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,4CAA4C;EAC5C,iCAAiC;AACnC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,yCAAyC;EACzC,YAAY;AACd;;AAEA;EACE,+CAA+C;EAC/C,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA,0BAA0B;AAC1B;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;AACF","sourcesContent":["/**\n * WelcomeDialog Styles\n * Designed for older users: large text, clear buttons, friendly design\n */\n\n.welcome-dialog-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.75);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 2500; /* Above modals but below tutorial overlay */\n  padding: 20px;\n}\n\n.welcome-dialog {\n  /* Glassmorphism effect */\n  background: rgba(255, 255, 255, 0.9);\n  backdrop-filter: blur(12px);\n  -webkit-backdrop-filter: blur(12px);\n  border: 1px solid rgba(255, 255, 255, 0.3);\n  border-radius: 20px;\n  padding: 40px;\n  max-width: 420px;\n  width: 100%;\n  text-align: center;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);\n  animation: welcome-appear 0.4s ease-out;\n}\n\n@keyframes welcome-appear {\n  from {\n    opacity: 0;\n    transform: scale(0.9);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n.welcome-dialog-logo {\n  margin-bottom: 24px;\n}\n\n.welcome-logo {\n  width: 120px;\n  height: auto;\n}\n\n.welcome-title {\n  font-size: 1.75rem;\n  font-weight: 700;\n  color: var(--color-text, #1f2937);\n  margin: 0 0 20px 0;\n  line-height: 1.3;\n}\n\n.welcome-message {\n  font-size: 1.15rem;\n  color: var(--color-text-secondary, #6b7280);\n  line-height: 1.6;\n  margin: 0 0 16px 0;\n}\n\n.welcome-tutorial-offer {\n  font-size: 1.1rem;\n  color: var(--color-text, #1f2937);\n  line-height: 1.5;\n  margin: 0 0 28px 0;\n  font-weight: 500;\n}\n\n.welcome-actions {\n  display: flex;\n  gap: 16px;\n  justify-content: center;\n}\n\n.welcome-btn {\n  padding: 16px 32px;\n  border-radius: 12px;\n  font-size: 1.1rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  border: none;\n  min-height: 52px;\n  min-width: 140px;\n}\n\n.welcome-btn-skip {\n  background: var(--color-background, #f3f4f6);\n  color: var(--color-text, #1f2937);\n}\n\n.welcome-btn-skip:hover {\n  background: var(--color-border, #d1d5db);\n}\n\n.welcome-btn-tutorial {\n  background: var(--color-primary, #3b82f6);\n  color: white;\n}\n\n.welcome-btn-tutorial:hover {\n  background: var(--color-primary-hover, #2563eb);\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);\n}\n\n/* Mobile responsiveness */\n@media (max-width: 480px) {\n  .welcome-dialog {\n    padding: 32px 24px;\n  }\n\n  .welcome-logo {\n    width: 100px;\n  }\n\n  .welcome-title {\n    font-size: 1.5rem;\n  }\n\n  .welcome-message,\n  .welcome-tutorial-offer {\n    font-size: 1rem;\n  }\n\n  .welcome-actions {\n    flex-direction: column;\n  }\n\n  .welcome-btn {\n    width: 100%;\n    min-width: unset;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
